var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: {
        info: true,
        "info--full": _vm.hasLeader && _vm.full,
        "info--center": _vm.center,
      },
    },
    [
      _c(
        "yxt-tooltip",
        {
          staticClass: "item",
          attrs: {
            effect: "dark",
            disabled: !_vm.full,
            enterable: false,
            content: _vm.content,
            "open-delay": 0,
            "hide-delay": 0,
            placement: _vm.placement,
          },
        },
        [
          _c(
            "div",
            { ref: "content", staticClass: "info__content" },
            [_vm._t("default")],
            2
          ),
        ]
      ),
      _vm.leader
        ? _c("yxt-tag", { attrs: { size: "medium" } }, [
            _vm._v(_vm._s(_vm.$t("pc_biz_group_leader" /* 组长 */))),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }